// extracted by mini-css-extract-plugin
export var compactFilters = "_f4-4";
export var detailImage = "_f4-1";
export var dropdownContainer = "_f4-2";
export var imageContainer = "_f4-0";
export var selectedCard = "_f4-3";